<template>
    <div>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div v-else>
            <v-card elevation="6" class="pa-2">
                <div v-if="loading_logs === true">
                    <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                    </v-sheet>
                </div>
                <div v-else>
                    <v-form ref="search" @submit.prevent="search_lots">
                        <div class="grid_full">
                            <div class="pa-4 grid_flex">
                                <v-autocomplete clearable color="#86bc3a" class="mr-1 ml-1" :items="logs_list"
                                    item-text="product_name" item-value="id" type="text" v-model="lot_number"
                                    label="ชื่อสินค้า" :rules="[v => !!v || 'กรุณากรอกชื่อสินค้า']" hide-details="auto"
                                    outlined :filter="customFilter"></v-autocomplete>
                                <v-btn x-large type="submit" class="grad-success-bg white--text btn_mobile"
                                    style="font-size: 18px">ค้นหา</v-btn>
                            </div>
                        </div>
                    </v-form>
                </div>
                <div v-if="this.extend_page !== false">
                    <!-- header -->
                    <div class="ma-4 border_card">
                        <div class="pa-4 d-flex flex-wrap align-center">
                            <div class="mr-2 font-weight-bold">ชื่อสินค้า :</div>
                            <div class="mr-6">{{ lot_detail.product_name }}</div>

                            <div class="mr-2 font-weight-bold">ซัพพลายเออร์ :</div>
                            <div>{{ lot_detail.supplier_name }}</div>
                        </div>
                    </div>

                    <!-- ตารางประวัติล็อตสินค้า -->
                    <div class="ma-4 border_card" v-if="lot_history.length > 0">
                        <v-card-title>
                            ประวัติล็อตสินค้า
                        </v-card-title>
                        <v-data-table :headers="header_lot_history" :items="lot_history" :footer-props="footer_Props"
                            mobile-breakpoint="0">
                            <template slot="item" slot-scope="dataDetail">
                                <tr>
                                    <td>{{ dataDetail.item.lot_no }}</td>
                                    <td>{{ dataDetail.item.product_name }}</td>
                                    <td>{{ dataDetail.item.date_exp_formatted }}</td>
                                    <td class="text-center">
                                        <v-btn small color="#86bc3a" dark @click="viewLotDetail(dataDetail.item)">
                                            ดูรายละเอียด
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </div>
                </div>
                <v-overlay :value="overlay" class="z_index">
                    <div class="text-center">
                        <v-progress-circular indeterminate size="70" width="7" color="#86bc3a"></v-progress-circular>
                        <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
                    </div>
                </v-overlay>
            </v-card>
        </div>
    </div>
</template>

<script>
import { HTTP } from "@/axios";
import Swal from "sweetalert2";
import { diffChangeFormat } from "@/js/handler";

export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: false,
            loading_logs: false,
            lot_number: this.$store.state.lot_number,
            lot_number_product_id: this.$store.state.lot_number_product_id,
            lot_number_product_date: this.$store.state.lot_number_product_date,
            extend_page: false,
            overlay: false,
            footer_Props: {
                'items-per-page-text': 'รายการต่อหน้า'
            },
            header_lot_history: [
                {
                    text: 'ชื่อล็อต',
                    value: 'lot_no',
                    sortable: false,
                    fixed: true,
                },
                {
                    text: 'ชื่อสินค้า',
                    value: 'product_name',
                    sortable: false,
                    fixed: true,
                },
                {
                    text: 'วันหมดอายุ',
                    value: 'date_exp_formatted',
                    sortable: false,
                    fixed: true,
                },
                {
                    text: 'จัดการ',
                    value: 'actions',
                    sortable: false,
                    fixed: true,
                    align: 'center',
                }
            ],
            lot_detail: [],
            log_detail: [],
            data_list: [],
            logs_list: [],
            lot_history: [],
        }
    },
    methods: {
        customFilter(item, queryText) {
            const textOne = item.product_name.toLowerCase()
            const textTwo = item.lot_no.toLowerCase()
            const textThree = item.search_logs.toLowerCase()
            const searchText = queryText.toLowerCase()

            return textOne.indexOf(searchText) > -1 ||
                textTwo.indexOf(searchText) > -1 ||
                textThree.indexOf(searchText) > -1
        },
        diffChange: function (value) {
            return diffChangeFormat(value)
        },
        get_search() {
            this.loading_logs = true
            HTTP.post('/stocks/alllots')
                .then((res) => {
                    if (res.data.success === true) {
                        this.loading_logs = false

                        const productMap = new Map()
                        res.data.object.forEach(item => {
                            const key = item.product_id
                            if (!productMap.has(key)) {
                                productMap.set(key, item)
                            }
                        })

                        this.logs_list = Array.from(productMap.values())

                        if (this.lot_number) {
                            const lot_no = res.data.object.find((detail) =>
                                detail.lot_no == this.lot_number &&
                                detail.product_id == this.lot_number_product_id &&
                                detail.date_exp == this.lot_number_product_date
                            )
                            if (lot_no) {
                                this.lot_number = lot_no.id
                            }
                        }
                    }
                })
        },
        async search_lots() {
            this.data_list = []
            this.lot_history = []
            if (this.$refs.search.validate()) {
                this.overlay = true
                const lot_no = this.logs_list.find((detail) => detail.id == this.lot_number)

                HTTP.post('stocks/history-by-product', {
                    product_id: lot_no.product_id
                })
                    .then((res) => {
                        if (res.data.success === true) {
                            this.lot_history = res.data.data
                        }
                    })
                    .catch((error) => {
                        console.error('Error fetching lot history:', error)
                    })

                HTTP.post('/stocks/lots', {
                    id: lot_no.id,
                    lot_no: lot_no.lot_no,
                    product_id: lot_no.product_id,
                }).then((res) => {
                    if (res.data.success === true) {
                        this.overlay = false
                        this.extend_page = true
                        this.lot_detail = res.data.object.lot_detail
                        this.data_list.push(
                            {
                                sell_name: 'ขาย',
                                sell: res.data.object.sell,
                                warehouse_main_name: 'คลังหลัก',
                                warehouse_main: res.data.object.warehouse_main,
                                warehouse_expireds_name: 'คลังใกล้หมดอายุ',
                                warehouse_expireds: res.data.object.warehouse_expireds,
                                warehouse_damage_name: 'คลังชำรุด',
                                warehouse_damage: res.data.object.warehouse_damage,
                                warehouse_return_name: 'คลังรอคืน',
                                warehouse_return: res.data.object.warehouse_return,
                                warehouse_dump_name: 'คลังรอลดหนี้',
                                warehouse_dump: res.data.object.warehouse_reduct,
                                warehouse_trash_name: 'คลังทิ้ง',
                                warehouse_trash: res.data.object.warehouse_dump,
                                warehouse_promotion_name: 'คลังโปรโมชั่น',
                                warehouse_promotion: res.data.object.warehouse_promotion,
                            },
                        )
                        this.log_detail = res.data.object.log_detail
                        this.$store.commit('temp_clear')
                        this.$store.commit('temp_lots_product_clear')
                    }
                    else {
                        this.overlay = false
                        this.extend_page = false
                        Swal.fire({
                            text: 'ไม่พบข้อมูลที่ค้นหา',
                            icon: 'error',
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonText: `ตกลง`,
                            denyButtonText: `ยกเลิก`,
                        }).then(() => {
                            this.$store.commit('temp_clear')
                            this.$store.commit('temp_lots_product_clear')
                            this.lot_number = null
                            this.lot_detail = null
                            this.data_list = []
                            this.lot_history = []
                        })
                    }
                })
            }
            else {
                this.extend_page = false
            }
        },
        viewLotDetail(item) {
  // เปลี่ยนจาก SearchProductLots เป็น SearchProductLotsDetail
  this.$router.push({
    name: 'SearchProductLotsDetail',  // ⭐ แก้ตรงนี้
    query: {
      id: item.id,
      lot_no: item.lot_no,
      product_id: item.product_id,
      date_exp: item.date_exp_original
    }
  }).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      console.error(err)
    }
  })
}
    },
    mounted() {
        this.get_search()
    }
}
</script>

<style scoped>
.border_card {
    border: #b3b3b3 solid 1px;
}

.grid_full {
    display: grid;
    grid-template-columns: 100%;
}

.grid_flex {
    display: flex;
}

.btn_mobile {
    width: 20%;
}

@media only screen and (max-width: 500px) {
    .grid_flex {
        display: block;
    }

    .btn_mobile {
        width: 100%;
        margin-top: 15px;
    }
}
</style>